import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { SocialUser } from '@abacritt/angularx-social-login';
import { Observable } from 'rxjs';
import { AuthService } from '../service/auth.service';

@Component({
  selector: 'app-login-dev',
  templateUrl: './login-dev.component.html',
  styleUrls: ['./login-dev.component.scss']
})
export class LoginDEVComponent implements OnInit {


  authState$: Observable<SocialUser>;
  encryptStno: string = "";
  sl: string = "";
  
  constructor(private auth: AuthService, private router: Router, route: ActivatedRoute) {
    this.authState$ = auth.authState$;

		let searchParams = new URLSearchParams(window.location.search);
		this.encryptStno = (searchParams.get('q') == null ? "" : searchParams.get('q')) ?? "";
    this.sl = (searchParams.get('sl') == null ? "" : searchParams.get('sl')) ?? "";
    if(this.encryptStno != null && this.encryptStno != "")
    {
      this.auth.simulateLoginDecrypt(encodeURIComponent(this.encryptStno)).subscribe(data => {
        console.log(data);
        if(data != null && data.studentNo != '' && data.expired != ''){
          var current = new Date();
          var expired = new Date(data.expired);
          if(current < expired)
            this.testLogin(data.studentNo, this.sl != "");
          else
            this.router.navigate(['/login'])
        }
        else
          this.router.navigate(['/login'])
     });
    }
  }



  ngOnInit(): void {
  }



  testLogin(stno: string, sl: boolean) {
    this.auth.loginForTesting(stno, sl);
    this.router.navigate(['/'])
  }

}
